/**
 * FundingResourceAdminPage (P429.2).
 *
 * Mount point for /foundation/admin/funding-resources. Thin wrapper handing
 * the adapter to the shared AdminListView, as every other register does.
 */
import { AdminListView } from "./AdminListView";
import { fundingResourceAdapter } from "./fundingResourceAdapter";

export function FundingResourceAdminPage() {
  return <AdminListView adapter={fundingResourceAdapter} />;
}
